import styled from "styled-components";

export const MapButtonSpace = styled.div`
  height: 15px;
`;